var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-color":"#a94442","inactive-color":"#3c763d"},on:{"change":_vm.handleChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }